import { useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { toast } from "sonner";

const DeleteAccount = () => {
  const [email, setEmail] = useState("");
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const navigate = useNavigate();

  // Email validation using regex
  const isValidEmail = useMemo(() => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }, [email]);

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  };

  const handleDeleteClick = () => {
    if (!isValidEmail) {
      toast.error("Please enter a valid email address");
      return;
    }
    setIsDialogOpen(true);
  };

  const handleDelete = () => {
    setIsDialogOpen(false);
    toast.success("Account deleted successfully");
    setTimeout(() => {
      navigate("/");
    }, 2000);
  };

  return (
    <div className="min-h-screen flex flex-col items-center pt-20">
      <h1 className="text-3xl font-bold mb-8">Delete Account</h1>
      
      <div className="w-full max-w-md space-y-4">
        <div className="space-y-2">
          <Input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={handleEmailChange}
            className={`w-full ${!isValidEmail && email !== "" ? 'border-red-500' : ''}`}
          />
          {!isValidEmail && email !== "" && (
            <p className="text-sm text-red-500">Please enter a valid email address</p>
          )}
        </div>
        
        <Button 
          variant="destructive" 
          className="w-full"
          onClick={handleDeleteClick}
          disabled={!isValidEmail || email === ""}
        >
          Delete Account
        </Button>
      </div>

      <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Are you sure?</DialogTitle>
            <DialogDescription>
              This action cannot be undone. This will permanently delete your account 
              associated with {email}.
            </DialogDescription>
          </DialogHeader>
          <DialogFooter>
            <Button variant="outline" onClick={() => setIsDialogOpen(false)}>
              Cancel
            </Button>
            <Button variant="destructive" onClick={handleDelete}>
              Confirm Delete
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default DeleteAccount; 